export default __webpack_public_path__ + "static/braum-3e33a59b32288b5592e7176c47811625.png";